import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { CarouselProvider } from 'pure-react-carousel';
import SlideGenerator from '../../components/DigitalMuseum/SlideGenerator/SlideGenerator';
import { setNavBarState, setLoaded, addToVisitedStories } from '../../store/reducers/mainReducer';
import { getStoryIndex } from '../../models/Utils';
import { ADALandmarks } from '../../models/ADA';
import './Home.scss';

const Home = () => {
  const dispatch = useDispatch();
  let { storyId } = useParams();
  let history = useHistory();
  const initialized = useSelector(state => state.data.initialized);
  const cmsData = useSelector(state => state.data.cms.digitalMuseum);

  useEffect(() => {
    dispatch(setNavBarState({ navbarVisibility: true }));
    dispatch(setLoaded());
  }, [dispatch]);

  if (!initialized || !cmsData) return null;

  const storyIndex = getStoryIndex(storyId, cmsData, history);
  const story = cmsData.AllStories[storyIndex];
  if(storyIndex < 0) {
    return null
  }

  document.title = "The Verizon Story - " + story.Header;
 
  dispatch(addToVisitedStories(storyIndex));

  return (
    <CarouselProvider
      className="full-carousel"
      orientation="vertical"    
      naturalSlideWidth="100vw"
      naturalSlideHeight="100vh"    
      totalSlides={story.Cards.length + 1}
      dragStep={1}
      lockOnWindowScroll={true}
      touchEnabled={false}
      dragEnabled={false}
      role={ADALandmarks.Main}
    >
      <SlideGenerator story={story} id={storyIndex} stories={cmsData.AllStories} />
    </CarouselProvider>
  );
};

export default Home;
